import React from 'react';

function ForgotPassword() {
  return <p>ForgotPassword</p>;
}

export default ForgotPassword;
